$(document).ready(function () {
    console.log('hello JS loaded');
    console.log( document.location.host );

    if( document.location.host == '127.0.0.1:9292' ) {
        console.log( 'local' );
        // console.log('USA Store Welcome');
        // console.log($('#lakai-crew-cta-footer'));
        // console.log($('#lakai-crew-cta-footer').css('display', 'none'));
        // $('#lakai-crew-cta-footer').css('display', 'none');
    }
    const isDesktop = window.matchMedia('(min-width: 1025px)').matches;
    if( isDesktop ) {
        document.querySelectorAll( '.header__links-summary' ).forEach( ( header ) => {
            header.addEventListener( 'mouseenter', () => {
                header.nextElementSibling.classList.add('top-20');
                header.parentElement.open = true;
                header.ariaExpanded = true;
            });
            header.addEventListener( 'mouseleave', () => {
                header.nextElementSibling.classList.remove('top-20');
                header.parentElement.open = false;
                header.ariaExpanded = false;
            });
        });
    
        document.querySelectorAll('.mega-liquid__content').forEach( (header_content) => {
            header_content.addEventListener( 'mouseenter', () => {
                $('.header__links-summary')[0].nextElementSibling.classList.add('top-20');
                $('.header__links-summary')[0].parentElement.open = true;
                $('.header__links-summary')[0].ariaExpanded = true;
            });
            header_content.addEventListener( 'mouseleave', () => {
                $('.header__links-summary')[0].nextElementSibling.classList.remove('top-20');
                $('.header__links-summary')[0].parentElement.open = false;
                $('.header__links-summary')[0].ariaExpanded = false;
            });
        });
    }
    else {
        document.querySelectorAll( '.burger-menu-mobile' ).forEach( ( header_mobile ) => {
            header_mobile.addEventListener( 'touchstart', () => {
                header_mobile.parentElement.firstElementChild.classList.remove('show-item');
                header_mobile.parentElement.firstElementChild.classList.add('shrink-item');
                header_mobile.parentElement.firstElementChild.classList.add('burger-hide');
                header_mobile.parentElement.lastElementChild.classList.remove('shrink-item');
                header_mobile.parentElement.lastElementChild.classList.add('show-item');
                header_mobile.parentElement.lastElementChild.classList.add('burger-show-hide');
                header_mobile.parentElement.nextElementSibling.classList.add('drawer-liquid-open');
            });
        });
        document.querySelectorAll( '.close-menu-mobile' ).forEach( ( header_mobile_close ) => {
            header_mobile_close.addEventListener( 'touchstart', () => {
                header_mobile_close.parentElement.firstElementChild.classList.add('show-item');
                header_mobile_close.parentElement.firstElementChild.classList.remove('shrink-item');
                header_mobile_close.parentElement.firstElementChild.classList.remove('burger-hide');
                header_mobile_close.parentElement.lastElementChild.classList.add('shrink-item');
                header_mobile_close.parentElement.lastElementChild.classList.remove('show-item');
                header_mobile_close.parentElement.lastElementChild.classList.remove('burger-show-hide');
                header_mobile_close.parentElement.nextElementSibling.classList.remove('drawer-liquid-open');
            });
        });
    }


    // Header accordion JS
    var title__box = document.getElementsByClassName("footer-accordion__title-box");
    var content__box = document.getElementsByClassName("footer-block__details-content");
    var i;

    for (i = 0; i < title__box.length; i++) {
        title__box[i].addEventListener("click", function() {
            this.classList.toggle("active");
            var panel = this.nextElementSibling;
            if (panel.style.maxHeight) {
                content__box[0].style.borderBottom = 'initial';
                content__box[0].style.borderTop = 'initial';
                panel.style.maxHeight = null;
            } else {
                content__box[0].style.borderBottom = 1 + 'px solid #E5E7EB';
                content__box[0].style.borderTop = 1 + 'px solid #E5E7EB';
                panel.style.maxHeight = panel.scrollHeight + "px";
            } 
        });
    }

    $('#newAddToCartIDNoVariant').click( function(e) {
        e.preventDefault();
        var url = window.location.href;
        var variantIdd = $('#newAddToCartIDNoVariantValue').val();
        $('#newAddToCartIDNoVariant').prop('disabled', true);
        $('#newAddToCartIDNoVariant')[0].classList.add('cursor-disable');
        $('.type-to-changee').text( 'Adding to bag' );
        $('.type-to-dott').css( 'display', 'none' );
        $('.type-to-pricee').css( 'display', 'none' );
        console.log(  );
        var productData = {
            id: variantIdd, 
            quantity: 1 
        };
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: productData,
            dataType: 'json',
            success: function(response) {
                var updates = {};
                updates[variantIdd] = 1;
            
                $.ajax({
                    type: 'GET',
                    url: '/cart.js',
                    dataType: 'json',
                    success: function(cart) {
                        updateCartUI(cart);
                    },
                    error: function(xhr, status, error) {
                        console.error('Error fetching cart:', error);
                        alert('There was an error fetching the cart.');
                    }
                });
                $('#newAddToCartIDNoVariant').prop('disabled', false);
                $('#newAddToCartIDNoVariant')[0].classList.remove('cursor-disable');
                $('.type-to-changee').text( 'Add to bag' );
                $('.type-to-dott').css( 'display', 'block' );
                $('.type-to-pricee').css( 'display', 'block' );
            },
            error: function(xhr, status, error) {
                console.error('Error adding item to cart:', error);
            }
        });
    });

    $('#newAddToCartID').click( function(e) {
        e.preventDefault();
        var url = window.location.href;
        var variantId = new URLSearchParams(window.location.search).get("variantId");
        // Check if variantId is not null
        if ( variantId != 'null' || variantId != null ) {
            $('#newAddToCartID').prop('disabled', true);
            $('#newAddToCartID')[0].classList.add('cursor-disable');
            $('.type-to-change').text( 'Adding to bag' );
            $('.type-to-dot').css( 'display', 'none' );
            $('.type-to-price').css( 'display', 'none' );
            if( variantId == null || variantId == 'null' ) {
                variantId = $('#newAddToCartIDColorVariantValue').val();
            }
            var productData = {
                id: variantId, 
                quantity: 1 
            };
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: productData,
                dataType: 'json',
                success: function(response) {
                    var updates = {};
                    updates[variantId] = 1;
                
                    $.ajax({
                        type: 'GET',
                        url: '/cart.js',
                        dataType: 'json',
                        success: function(cart) {
                            updateCartUI(cart);
                            $('#newAddToCartID').prop('disabled', false);
                            $('#newAddToCartID')[0].classList.remove('cursor-disable');
                            $('.type-to-change').text( 'Add to bag' );
                            $('.type-to-dot').css( 'display', 'block' );
                            $('.type-to-price').css( 'display', 'block' );
                        },
                        error: function(xhr, status, error) {
                            console.error('Error fetching cart:', error);
                            alert('There was an error fetching the cart.');
                        }
                    });
                    $('#newAddToCartID').prop('disabled', false);
                },
                error: function(xhr, status, error) {
                    console.error('Error adding item to cart:', error);
                }
            });
        } 
        else {
            $('#newAddToCartID').prop('disabled', true);
        }
    });
    function updateCartUI(cart) {
        $('.drawer__inner-empty').remove();
        if( $('.cart-drawer-items-box')[0].classList.contains('is-empty') ) {
            $('.cart-drawer-items-box')[0].classList.remove('is-empty');
            $('.drawer-liquid')[0].classList.remove('is-empty');
            $('.drawer__header').css('display', 'block');
            $('.drawer__header ').css('display', 'flex');
            $('.drawer__footer').css('display', 'flex');
        }
        $('.cart-item-box').empty();
        cart.items.forEach(function(item, index) {
            var loopI = index + 1;
            var newTitle = item.title;
            var charArray = newTitle.split("-");
            $('.cart-item-box').append(
                '<div id="CartDrawer-Item-' + loopI + '"  class="grid grid-cols-3 gap-4 border-b px-4 relative">' +
                    '<div class="dots-loading-box dots-loading-box-' + loopI + ' z-50 flex justify-center items-center absolute top-0 left-0 w-full h-full bg-black/50">' +
                        '<div class="dots-container">' +
                            '<div class="dot-loading"></div>' +
                            '<div class="dot-loading"></div>' +
                            '<div class="dot-loading"></div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="absolute bottom-4 right-4 cursor-pointer">' +
                        '<cart-remove-button id="CartDrawer-Remove-' + loopI + '" data-index="' + loopI + '"">' +
                            '<button type="button" class="button button--tertiary cart-remove-button" aria-label="' + item.title + '" data-variant-id="' + item.variant_id + '">' +
                                '<span class="svg-wrapper">' +
                                    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trash hover:text-red-500 size-5">' +
                                        '<path d="M3 6h18"></path><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>' +
                                        '<path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>' +
                                    '</svg>' +
                                '</span>' +
                            '</button>' +
                        '</cart-remove-button>' +
                    '</div>' +
                    '<div class="aspect-[4/5] h-full py-4 w-full">' +
                        '<img src="' + item.image + '" alt="' + item.title + '" class="w-full h-full object-contain" width="" height="">' +
                    '</div>' +
                    '<div class="flex flex-col col-span-2 justify-center uppercase">' +

                        '<h6 class="font-akkurat-pro-bold text-lg">' + charArray[0] + ' </h6>' +
                        '<div class="flex gap-1 items-center">' +
                            '<p class="font-akkurat-mono font-bold text-black text-sm">' + item.options_with_values[0].value + '</p>' +
                            '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-minus text-black -rotate-45 size-4">' +
                              '<path d="M5 12h14"></path>' +
                            '</svg>' +
                            '<p class="font-akkurat-mono font-bold text-black text-sm">' + item.options_with_values[1].value + '</p>' +
                        '</div>' +
                        '<div class="flex flex-row gap-2 items-center my-1">' +
                            '<quantity-input class="quantity cart-quantity">' +
                                '<button class="quantity__button" name="minus" type="button">' +
                                    '<span class="visually-hidden">Decrease quantity for ' + item.title + '</span>' +
                                    '<span class="svg-wrapper">' +
                                        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-minus size-4 text-black/50 hover:text-black cursor-pointer">' +
                                            '<path d="M5 12h14"></path>' +
                                        '</svg>' +
                                    '</span>' +
                                '</button>' +
                                '<input class="quantity__input quantity__input-liquid" type="number" data-quantity-variant-id="' + item.variant_id + '" name="updates[]" value="' + item.quantity + '" data-cart-quantity="1" min="0" data-min="1" step="1" aria-label="Quantity for ' + item.title + '" id="Drawer-quantity-' + loopI + '" data-index="1">' +
                                '<button class="quantity__button" name="plus" type="button">' +
                                    '<span class="visually-hidden">Increase quantity for ' + item.title + '</span>' +
                                    '<span class="svg-wrapper">' +
                                        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-plus size-4 text-black/50 hover:text-black cursor-pointer">' +
                                            '<path d="M5 12h14"></path>' +
                                            '<path d="M12 5v14"></path>' +
                                        '</svg>' +
                                    '</span>' +
                                '</button>' +
                            '</quantity-input>' +
                        '</div>' +
                        '<div class="items-center flex flex-row gap-2">' +
                            '<h6 class="font-akkurat-pro-bold">' + window.currencySymbol + (item.price / 100).toFixed(2) + '</h6>' +
                        '</div>' +
                    '</div>' +
                '</div>'
            );
        });
        if( cart.total_price <= 9900 ) {
            $('.cart-progress-bar').css('width', (cart.total_price / 100).toFixed(2) + '%');
            $('#toUnlock').text( window.currencySymbol + ( ( 9900 - cart.total_price ) / 100 ).toFixed(2) );
        }
        else {
            $('.cart-progress-bar').css('width', '100%');
            $('#toUnlockHeader').text("You've unlocked free shipping")
        }
        $('#drawerHeadingCount').text( 'Bag • ' + cart.item_count + ' items' );
        $('#CartDrawer-Checkout').prop('disabled', false);
        $('.header__liquid-bag-word').text( 'BAG(' + cart.item_count + ')' );
        $('.cart-footer-subtotal').text(window.currencySymbol + (cart.total_price / 100).toFixed(2));
        $('.cart-footer-total').text(window.currencySymbol + (cart.total_price / 100).toFixed(2));
        $('body')[0].classList.add('overflow-hidden');
        $('.drawer-liquid')[0].classList.add('active');
    }

    $('#cart-icon-bubble-liquid').click( function(e) {
        e.preventDefault();
        $('body')[0].classList.add('overflow-hidden');
        $('.drawer-liquid')[0].classList.add('active');
    });

    document.querySelectorAll('.product-variant-types').forEach( ( type ) => {
        type.addEventListener( 'click', () => {
            $('#newAddToCartID').prop('disabled', false);
            $('#newAddToCartID')[0].classList.remove('cursor-disable');
            $('.type-to-change').text( 'Add to bag' );
        });
    });
    // CODE ONLY ABOVE THIS LINE AS DOCOMENT.READY ENDS HERE
});